import React from 'react'
import StackedTeaser from '../atoms/StackedTeaser'
import Headline from '../atoms/Headline'
import SbEditable from 'storyblok-react'
import PostitTeaser from '../atoms/PostitTeaser'
import PolaroidTeaser from '../atoms/PolaroidTeaser'

const TripleTeaserBlock = ({ block, className }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`triple-teaser-block ${className} ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''}`}
      >
        <div className="triple-teaser-block-container">
          <div className="triple-teaser-block-wrapper">
            <Headline
              kicker={block.kicker}
              headline={block.headline}
              subheadline={block.subheadline}
            />

            <div className="triple-teaser-block-row triple-teaser justify-content-start">
              {block.teaser?.length > 0 &&
                block.teaser.map((item, index) => (
                  <React.Fragment key={index}>
                    {item.component === 'stacked_teaser_item' && (
                      <StackedTeaser
                        className="stacked-teaser-item-card"
                        item={item}
                        key={index}
                      />
                    )}
                    {item.component === 'postit_teaser_item' && (
                      <PostitTeaser item={item} />
                    )}
                    {item.component === 'polaroid_teaser_item' && (
                      <PolaroidTeaser item={item} />
                    )}
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default TripleTeaserBlock
